import { AppMetadataHandler } from './../../BaseFramework/configs/app-metadata.handler';
import { filter, delay, share } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject, forkJoin, zip, of, pipe, BehaviorSubject } from 'rxjs';
import { TranslateService } from '../../BaseFramework/core/http/translate.service';
import { ApiRequestService } from '../../BaseFramework/core/http/api-request.service';
import { RequirementService } from '../../BaseFramework/core/http/requirement.service'
import * as allModels from './models'
import { environment } from 'environments/environment';

@Injectable()
export class PolicyService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        public appMetadataHandler: AppMetadataHandler,
        private requirementService: RequirementService
    ) { }

    //Fetch a single policy based on id

    getPolicies(id: number): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        params.set('id', typeof id === "number" ? id.toString() : "0");

        let policyDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        let pathVariables = [];
        pathVariables.push(id);
        this.apiRequest.getCallWithAPIMapper('fetchProposalById', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                policyDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return policyDataSubject;
    }

    getPolicyByGuid(guid: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let policyDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper('policyfetchByGuid', null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper('policyFetchByGuid' + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                this.requirementService.fetchDocuments(guid)
                    .subscribe(resp => {
                        returnObj['entityDocumentDOs'] = resp;
                        policyDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    })

            });

        return policyDataSubject;
    }

    // temporary added by abhishek, can be moved to another service
    getCaseByGuid(guid: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let caseDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper('fetchCaseByGuid', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                caseDataSubject.next(returnObj);
            });

        return caseDataSubject;
    }

    savePolicies(proposalIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.postCallWithAPIMapper('proposalSave', proposalIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    saveCounterPolicies(proposalIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.postCallWithAPIMapper('proposalCounterOfferSave', proposalIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }



    submitPolicies(proposalIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.postCallWithAPIMapper('policySubmit', proposalIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    submitCounterPolicies(proposalIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        let url = 'proposalCounterOfferSubmit'
        this.apiRequest.postCallWithAPIMapper(url, proposalIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    saveCase(caseIO): Observable<any> {
        let self = this;
        let caseDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        let url = 'caseSave'
        this.apiRequest.postCallWithAPIMapper(url, caseIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                caseDataSubject.next(jsonResp);

            }, errResp => {
                caseDataSubject.next(errResp);
            })
        return caseDataSubject;
    }

    submitCase(caseIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        let url = 'caseSubmit'
        this.apiRequest.postCallWithAPIMapper(url, caseIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    saveCounterResponse(proposalIO): Observable<any> {
        let self = this;
        //let proposalIO = proposalIO
        let policyDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        let url = 'submitCounterOffer'
        this.apiRequest.postCallWithAPIMapper(url, proposalIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    // Policy search on basis of search parameters given in an array.
    searchPolicies(searchParam): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });
        let policySearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'searchPortal';
        var returnObj = "success";
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, criteriaArray)
            .subscribe(jsonResp => {
                let returnObj = jsonResp.map(function (v, i, a) {
                    let newRow = Object.assign({}, v, {
                        proposalNum: v.proposalNum,
                        baseProductCd: v.baseProductCd,
                        baseProductFamilyCd: v.baseProductFamilyCd,
                        statusCd: v.statusCd,
                    });
                    return newRow;
                });
                policySearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return policySearchData;
    }

    // Policy search on basis of search parameters given in an array.
    searchTravelPolicies(searchParam): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });
        let policySearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'searchTravelPortal';
        var returnObj = "success";
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, criteriaArray)
            .subscribe(jsonResp => {
                let returnObj = jsonResp.map(function (v, i, a) {
                    let newRow = Object.assign({}, v, {
                        proposalNum: v.proposalNum,
                        baseProductCd: v.baseProductCd,
                        baseProductFamilyCd: v.baseProductFamilyCd,
                        statusCd: v.statusCd,
                    });
                    return newRow;
                });
                policySearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return policySearchData;
    }

    getProducts(): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        let planType = "BASEPLAN";
        let productSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'fetchProductByPlanType';
        let pathVariables = [];
        pathVariables.push(planType);
        this.apiRequest.getCallWithAPIMapper(searchURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                productSearchData.next(jsonResp); // incidentList is a Subject and emits an event thats being listened to by the components
            });
        return productSearchData;
    }

    searchGenericPolicy(searchRequestDO, pageNum, pageSize): Observable<any> {
        let self = this;
        let policyDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax save quote attempt
        this.apiRequest.post('api/policy/searchPortalPoliciesForAgent' + '?page=' + pageNum + '&size=' + pageSize, searchRequestDO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    // return "Success"
                } else {
                    //return "failed"
                }
                policyDataSubject.next(jsonResp);

            }, errResp => {
                policyDataSubject.next(errResp);
            })
        return policyDataSubject;
    }

    getProposalIOByQuatationGuid(guid: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let policyDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper('createProposal', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                policyDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return policyDataSubject;
    }

    getQuestionnaire(quescd_array): Observable<any> {

        let observables = new Array();
        let QuesSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        for (let i = 0; i < quescd_array.length; i++) {
            let pathVariables = [];
            pathVariables.push(quescd_array[i]);
            observables.push(this.apiRequest.getCallWithAPIMapper('fetchByQuestionnaireCd', null, null, pathVariables));
        }

        forkJoin(observables).subscribe((res) => {
            let returnobj = res;
            QuesSubject.next(returnobj);
        })
        return QuesSubject;
    }

    getPolicyByPolicyNumOld(proposalNum: String): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let url;
        if (this.appMetadataHandler.featureFlags.enableInterfaceEndpoints)
            url = "interface/ods/policy/fetchByPolicyNum/"
        else
            url = "apiFetchByPolicyNum"

        let policyDataSubject: any = new Subject(); // Will use this subject to emit data that we want
        let pathVariables = [];
        pathVariables.push(proposalNum);
        this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)  //old
            // this.apiRequest.get('interface/ods/policy/fetchByPolicyNum/' + proposalNum)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                policyDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return policyDataSubject;
    }

    policyCallSubjects: any = {}
    getPolicyByPolicyCache = {}
    getPolicyByPolicy$
    getPolicyByPolicyNum(proposalNum: any, disableInterfaceCall?): Observable<any> {
        let enableInterfaceEndpoints = this.appMetadataHandler.featureFlags.enableInterfaceEndpoints
        if (disableInterfaceCall)
            enableInterfaceEndpoints = !disableInterfaceCall

        if (this.getPolicyByPolicyCache[proposalNum]) {
            return of(this.getPolicyByPolicyCache[proposalNum]).pipe(delay(100));
        }

        else if (this.policyCallSubjects[proposalNum]) {
            return this.policyCallSubjects[proposalNum]
        }
        else {
            let url;
            if (enableInterfaceEndpoints)
                url = "interface/ods/policy/fetchByPolicyNum/"
            else
                url = "apiFetchByPolicyNum"
            this.policyCallSubjects[proposalNum] = new Subject<any>();
            let pathVariables = [];
            pathVariables.push(proposalNum);
            this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.policyCallSubjects[proposalNum].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.getPolicyByPolicyCache[proposalNum] = returnObj
                    this.getPolicyByPolicyGuidCache[returnObj['guid']] = returnObj
                });
        }
        return this.policyCallSubjects[proposalNum];
    }

    policyCallGuidSubjects: any = {}
    getPolicyByPolicyGuidCache = {}
    getPolicyByPolicyGuid(guid: any): Observable<any> {

        if (this.getPolicyByPolicyGuidCache[guid]) {
            return of(this.getPolicyByPolicyGuidCache[guid]).pipe(delay(100));
        }

        else if (this.policyCallGuidSubjects[guid]) {
            return this.policyCallGuidSubjects[guid]
        }
        else {
            let url = 'policyfetchByGuid'
            this.policyCallGuidSubjects[guid] = new Subject<any>();
            let pathVariables = [];
            pathVariables.push(guid);
            this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
            // this.apiRequest.getCallWithAPIMapper(url + guid)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.policyCallGuidSubjects[guid].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.getPolicyByPolicyGuidCache[guid] = returnObj
                    this.getPolicyByPolicyCache[returnObj['proposalNum']] = returnObj

                });
        }
        return this.policyCallGuidSubjects[guid];
    }

    getProposalIOByPolicyNumList(policyList, disableInterfaceCall?) {
        let observables = []
        let proposalIOListSubject = new BehaviorSubject<any>([]);
        if (policyList && Array.isArray(policyList) && policyList.length > 0) {
            policyList.forEach(policySearchItem => {
                observables.push(this.getPolicyByPolicyNum(policySearchItem.proposalNum, disableInterfaceCall))
            });
        }
        zip(...observables)
            .subscribe(responses => {
                proposalIOListSubject.next(responses)
            })
        return proposalIOListSubject
    }

    extractSpecificRolesUsingPolicyList(policyList, extractRoleCd, mode?) {
        let clientListSubject = new BehaviorSubject<any>([]);
        let observables = []
        if (!extractRoleCd) {
            if (!environment.production) {
                throw "Role to extracted should be passed to the method 'extractSpecificRolesUsingPolicyList'";
            }
            else return of([])
        }
        if (policyList && Array.isArray(policyList) && policyList.length > 0) {
            policyList.forEach(element => {
                observables.push(this.getPolicyByPolicyNum(element.proposalNum))
            });
        }
        zip(...observables)
            .subscribe(responses => {
                let finalOutPut = [];
                if (responses && responses != null) {
                    responses.forEach(proposalIO => {
                        let filterOutput: any
                        if (extractRoleCd == 'BENEFICIARY' || mode == 'MULTIPLE') {
                            filterOutput = this.extractMultipleClientDOFromProposalIO(proposalIO, extractRoleCd)
                            filterOutput = this.setSplitPercentForNominee(proposalIO, filterOutput) // This is to be extracted only for Nominee/Beneficiary
                        }
                        else {
                            filterOutput = this.extractClientDOFromProposalIO(proposalIO, extractRoleCd)
                        }
                        finalOutPut.push(...filterOutput)
                    });
                    if (finalOutPut && finalOutPut != undefined) {
                        clientListSubject.next(finalOutPut);
                    }
                }
            });
        return clientListSubject;
    }

    setSplitPercentForNominee(proposalIO, listOfClients) {
        //SplitPercentIfAny
        if (proposalIO && proposalIO['proposalDO']) {
            let policyBeneficiaryList = proposalIO['proposalDO']['policyBeneficiaryList']
            if (policyBeneficiaryList && Array.isArray(policyBeneficiaryList) && policyBeneficiaryList.length > 0) {
                policyBeneficiaryList.forEach(policyBeneficiary => {
                    if (policyBeneficiary) {
                        let splitPercent = policyBeneficiary['splitPercent']
                        listOfClients.forEach(client => {
                            if (policyBeneficiary.beneficiaryClientRefGuid == client.guid)
                                client['nomineeSplitPrct'] = splitPercent || 0
                        });

                        // Copy to Claim Payments This is will be populated only when there is null/undefined in percentage split, zero is a acceptable input
                        // payload[DOName]['claimPayments'].forEach(claimPayment => {
                        //   if (policyBeneficiary.beneficiaryClientRefGuid == claimPayment.clientRefGuid
                        //     && (claimPayment['paymentSplitPrct'] === null || claimPayment['paymentSplitPrct'] === undefined))
                        //     claimPayment['paymentSplitPrct'] = splitPercent
                        // })
                    }
                })
            }
        }

        return listOfClients
    }



    extractClientDOFromProposalIO(proposalIO, extractRoleCd): Array<any> {
        let filterOutput = []
        if (proposalIO &&
            proposalIO['proposalDO'] &&
            proposalIO['proposalDO']['proposalClients'] &&
            Array.isArray(proposalIO['proposalDO']['proposalClients']) &&
            proposalIO['proposalDO']['proposalClients'].length > 0) {
            let ownerRefGuid = proposalIO['proposalDO']['proposalClients'].find(item => {
                if (item)
                    return item['roleCd'] === extractRoleCd;
            }) || []

            filterOutput = proposalIO['clientDOs'].filter(item => {
                if (item)
                    return item['guid'] === ownerRefGuid.clientRefGuid;
            }) || []
        }
        return filterOutput
    }

    extractMultipleClientDOFromProposalIO(proposalIO, extractRoleCd): Array<any> {
        let filterOutput = []
        if (proposalIO &&
            proposalIO['proposalDO'] &&
            proposalIO['proposalDO']['proposalClients'] &&
            Array.isArray(proposalIO['proposalDO']['proposalClients']) &&
            proposalIO['proposalDO']['proposalClients'].length > 0) {
            let filteredPolicyClients = proposalIO['proposalDO']['proposalClients'].filter(item => {
                if (item)
                    return item['roleCd'] === extractRoleCd;
            }) || []

            if (filteredPolicyClients && Array.isArray(filteredPolicyClients) && filteredPolicyClients.length > 0) {
                filteredPolicyClients.forEach(policyClient => {
                    let clientDO = proposalIO['clientDOs'].find(item => {
                        if (item)
                            return item['guid'] === policyClient.clientRefGuid;
                    })

                    if (clientDO)
                        filterOutput.push(clientDO)

                })
            }


        }
        return filterOutput
    }

    AgentCallSubjects: any = {}
    getAgentDOByAgentCache = {}
    getAgentDOByAgent$
    getAgentByAgentNum(agentNum: any): Observable<any> {

        if (this.getAgentDOByAgentCache[agentNum]) {
            return of(this.getAgentDOByAgentCache[agentNum]).pipe(delay(100));
        }

        else if (this.AgentCallSubjects[agentNum]) {
            return this.AgentCallSubjects[agentNum]
        }
        else {
            let url = "fetchByAgentNum";
            let pathVariables = [];
            pathVariables.push(agentNum);
            this.AgentCallSubjects[agentNum] = new Subject<any>();
            this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.AgentCallSubjects[agentNum].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.getAgentDOByAgentCache[agentNum] = returnObj
                });
        }
        return this.AgentCallSubjects[agentNum];
    }


    getListOfAgentDOsByProposalAgents(proposalAgents) {
        let observables = []
        let ListOfAgentDOsSubject = new BehaviorSubject<any>([]);
        if (proposalAgents && Array.isArray(proposalAgents) && proposalAgents.length > 0) {
            proposalAgents.forEach(agentListItem => {
                observables.push(this.getAgentByAgentNum(agentListItem.agentNum))
            });
        }
        zip(...observables)
            .subscribe(responses => {
                ListOfAgentDOsSubject.next(responses)
            })
        return ListOfAgentDOsSubject
    }


    validateLabData(CriteriaIO): Observable<any> {
        let labTestSubject = new Subject<any>();
        let url = 'validateLabtest'
        this.apiRequest.postCallWithAPIMapper(url, CriteriaIO)
            .subscribe(jsonResp => {
                labTestSubject.next(jsonResp);
            }, errResp => {
                labTestSubject.next(errResp);
            })
        return labTestSubject;
    }

}
